<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side.md
          side-nav(
          v-bind:sideNavData="sideNavData"
          )
        .profile-page__main.md
          //.profile-page__header
            .profile-page__title
              h1.title Создание смены
          .profile-page__tabs
            tab-nav(
            v-bind:tabNavData="tabNavData"
            )
          .profile-page__content
            section.profile-page-form__section.profile-section
              .profile-section__title
                h2.profile-section-title Общая информация
              .profile-section__body
                .form
                  .form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Название
                      .form-elem__body
                        input.input.input_full(
                        maxlength="50"
                        value="Английская"
                        )
                  .form__elem.form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Дата проведения
                      .form-elem__body.form-elem__body_double
                        date-picker(
                        placeholder="дд.мм.гггг"
                        v-model="localDateOfBirth"
                        format="DD.MM.YYYY"
                        lang="ru"
                        input-class="input input_full"
                          @change="onChangeDate($event)"
                            :clearable="false"
                            :editable="true"
                            :not-after="new Date()"
                        )
                        .separator -
                        date-picker(
                        placeholder="дд.мм.гггг"
                        v-model="localDateOfBirth"
                        format="DD.MM.YYYY"
                        lang="ru"
                        input-class="input input_full"
                          @change="onChangeDate($event)"
                            :clearable="false"
                            :editable="true"
                            :not-after="new Date()"
                        )
                  .form__elem.form__elem_short
                    .form-elem.form-elem_horizontal
                      .form-elem__title Количество человек
                      .form-elem__body
                        input.input.input_full(
                        maxlength="50"
                        value="45"
                        )
                  .form__elem.form__elem_short
                    .form-elem.form-elem_horizontal
                      .form-elem__title Базовая цена за смену
                      .form-elem__body
                        input.input.input_full(
                        maxlength="50"
                        value="5000"
                        )
                  .form__elem.form__elem_short
                    .form-elem.form-elem_horizontal
                      .form-elem__title Возраст участников
                      .form-elem__body.form-elem__body_double
                        input.input.input_sm(
                        maxlength="50"
                        placeholder="10"
                        )
                        .separator -
                        input.input.input_sm(
                        maxlength="50"
                        placeholder="17"
                        )
                  .form__elem.form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Сроки подачи заявок
                      .form-elem__body.form-elem__body_double
                        date-picker(
                        placeholder="дд.мм.гггг"
                        v-model="localDateOfBirth"
                        format="DD.MM.YYYY"
                        lang="ru"
                        input-class="input input_full"
                          @change="onChangeDate($event)"
                            :clearable="false"
                            :editable="true"
                            :not-after="new Date()"
                        )
                        .separator -
                        date-picker(
                        placeholder="дд.мм.гггг"
                        v-model="localDateOfBirth"
                        format="DD.MM.YYYY"
                        lang="ru"
                        input-class="input input_full"
                          @change="onChangeDate($event)"
                            :clearable="false"
                            :editable="true"
                            :not-after="new Date()"
                        )
                  .form__elem.form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Сроки заключения контрактов
                      .form-elem__body.form-elem__body_double
                        date-picker(
                        placeholder="дд.мм.гггг"
                        v-model="localDateOfBirth"
                        format="DD.MM.YYYY"
                        lang="ru"
                        input-class="input input_full"
                          @change="onChangeDate($event)"
                            :clearable="false"
                            :editable="true"
                            :not-after="new Date()"
                        )
                        .separator -
                        date-picker(
                        placeholder="дд.мм.гггг"
                        v-model="localDateOfBirth"
                        format="DD.MM.YYYY"
                        lang="ru"
                        input-class="input input_full"
                          @change="onChangeDate($event)"
                            :clearable="false"
                            :editable="true"
                            :not-after="new Date()"
                        )
                  .form__elem.form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Профильность
                      .form-elem__main.form-elem__main_md
                        .simple-select-form
                          .simple-select-form__button Тематическая
                          .simple-select-form__list
                            ul
                              li Тематическая
                              li Специализированная

            section.form__elem.form__elem--align-right.form__elem_full
              button.button.button_paint-main.button_long
                .button__text Сохранить
</template>
<script>
import {mapState, mapActions} from "vuex";

import MainFooter from "@/components/footer/Footer";
import SideNav from "@/components/sideNav/SideNav";
import TabNav from "../../../../components/tabNav/TabNav.vue";
import DatePicker from "vue2-datepicker";
import SimpleSelectForm from "../../../../components/simpleSelectForm/SimpleSelectForm.vue";

export default {
  name: "DirectorShiftsCreate",
  components: {
    SimpleSelectForm,
    DatePicker,
    TabNav,
    SideNav,
    MainFooter
  },
  props: ["sideNavData"],
  data() {
    return {
      tabNavData: {
        tabs: [
          {
            path: "/pages/director/shift/create",
            text: "Общая информация"
          },
          {
            path: "/pages/director/shift/quota",
            text: "Квоты"
          },
          {
            path: "/pages/director/shift/about",
            text: "Описание"
          },
          {
            path: "/pages/director/shift/program",
            text: "Программа"
          },
          {
            path: "/pages/director/shift/schedule",
            text: "Распорядок дня"
          },
          {
            path: "/pages/director/shift/teachers",
            text: "Педагоги"
          },
          {
            path: "/pages/director/shift/contacts",
            text: "Контакты"
          }
        ],
        profileListData: [
          {
            text: "Тематическая ",
            value: true
          },
          {
            text: "Специализированная",
            value: false
          }
        ]
      }
    };
  },
  computed: {
    localGender: {

    }
  },
  methods: {
    onSelectItem(li) {
      this.$emit("onSelectItem", li);
      this.$emit("close");
    },
    onClickList(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onBodyClick() {
      this.$emit("close");
    }
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
  created() {
    document.body.addEventListener("click", this.onBodyClick);
  }
//  computed: {
//    localDateOfBirth: {
//      get() {
//        if (!this.dateOfBirth) {
//          return "";
//        }
//        return this.dateOfBirth;
//      },
//      set() {}
//    },
//  },
//  methods: {
//    onChangeDate(date) {
//      const d = new Date(date);
//      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
//        -2
//      )}-${("0" + d.getDate()).slice(-2)}`;
//      this.$emit("onChangeValue", [_date, "date_of_birth"]);
//    },
//  }
};
</script>
